import { isHTMLElement } from './typeguards.js';

/**
 * Fixes cssText to be compatible with the CSSOM API.
 * @see https://drafts.csswg.org/cssom/#serialize-an-identifier
 *
 * @param input the cssText to fix
 * @returns a modified cssText
 */
const fixCssText = (input: string): string =>
    input.replace(/([^{]+)\{([^}]*)\}/g, (_, selectorGroup: string, declarations: string) => {
        // Escape only in the selector part
        const fixedSelector = selectorGroup.replace(/([#.])([^\s\.\:\#\[\]\{\}\)\(\"),>+~]+)/g, (_, prefix, name) => prefix + CSS.escape(name))
        // Reassemble the rule
        return `${fixedSelector}{${declarations}}`;
    });

/**
 * Adds a style element with the given cssText to the given node.
 *
 * @param cssText the cssText to add
 * @param node the node to add a style element to
 * @returns the created style element
 */
export const addCssToElement = (cssText: string, node: HTMLElement): HTMLStyleElement => {
    const targetNode = isHTMLElement(node) ? node : document.head;
    const cssNode = document.createElement('style');
    cssNode.textContent = fixCssText(cssText);
    targetNode.appendChild(cssNode);
    return cssNode;
};
